import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { TransactionRequest } from 'src/model/transactionRequest.model';

@Component({
    selector: 'app-add-assigned-transaction-into-account',
    templateUrl: './add-assigned-transaction-into-account.component.html',
    styleUrls: ['./add-assigned-transaction-into-account.component.scss'],
    standalone: false
})
export class AddAssignedTransactionIntoAccountComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);


  @Input() transactionRequest: TransactionRequest;
  accountDate: Date;
  selectedAccountId: number;

  disabledSubmit = false;

  companyAccountList: Account[] = [];

  ngOnInit(): void {
    const companyId = sessionStorage.getItem("companyId");
    this.getAllAccountsOfCompany(Number(companyId));
  }

  private getAllAccountsOfCompany(companyId: number) {
    const xhttp = this.restApi.getRequest(this.constructApi.getAccountsOfCompany(companyId))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);

          const isStaff = (Number(sessionStorage.getItem("roleId")) === Number(this.enums.STAFF)) ? true : false;

          const loggedInUser = sessionStorage.getItem("username");
          if (json.username == undefined) {
            if (!isStaff)
              this.companyAccountList.push(account);
          }
          else
            this.companyAccountList.push(account);
        });
      }
    };
  }

  submit() {
    if (this.selectedAccountId == undefined || this.accountDate == undefined)
      this.sharedService.openAlert("Please fill in all necessary fields: Date and Account", ALERT_TYPE.DANGER);
    else {
      this.disabledSubmit = true;

      const data = {
        "date": this.accountDate.toISOString(),
        "accountId": Number(this.selectedAccountId),
        "remark": this.transactionRequest.Remark
      }
      const xhr = this.restApi.postRequest(this.constructApi.getAddAssignedTransactionToAccount(this.transactionRequest.ID), data)
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4) {
          this.disabledSubmit = false;
          //if success , then proceed
          if (xhr.status == 200) {
            this.closeModal();
            window.location.reload();
          } else {
            //show error message
            this.sharedService.openAlert(JSON.parse(xhr.responseText).error, ALERT_TYPE.DANGER)
          }
        }
      }
    }
  }

  calculateTotalAmount() {
    let sum = 0
    for (let i = 0; i < this.transactionRequest.TransactionItems.length; i++) {
      sum += this.transactionRequest.TransactionItems[i].amount;
    }

    return sum
  }

  isBalanceInsufficient(balance: number) {
    if (this.calculateTotalAmount() < 0) {
      if (balance + this.calculateTotalAmount() < 0) {
        return true;
      }
    }
    return false;
  }

  closeModal() {
    this.activeModal.close();
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }

  calculateTotal() {
    let sum = 0;

    for (let i = 0; i < this.transactionRequest.TransactionItems.length; i++) {
      sum += this.transactionRequest.TransactionItems[i].amount;
    }
    return sum
  }
}
